import React from 'react';
import Arrowup from '../../assets/images/arrow_up.svg';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';

interface AccordionProps {
    id: number;
    index: number;
    isOpen: boolean;
    toggleOpen: (id: number) => void;
    header: React.ReactNode;
    content: React.ReactNode;
}

const Accordion: React.FC<AccordionProps> = ({
    id,
    isOpen,
    index,
    toggleOpen,
    header,
    content,
}) => {
    const isSelectOpen = useSelector(
        (state: RootState) => state.setSelectOpen.isOpen
    );
    return (
        <div className="border border-gray-200 h-full rounded-xl w-full my-[0.12rem] font-sans">
            <button
                data-testid="action-button"
                onClick={() => toggleOpen(id)}
                className={`w-full text-left px-4 py-4 h-full flex items-center justify-between bg-white border-b border-gray-200 focus:outline-none 
          ${isOpen ? 'rounded-t-xl' : 'rounded-xl'}
       `}
            >
                <div className="flex flex-row items-center">{header}</div>
                <div
                    className={`text-gray-500 text-xl transform  transition-transform duration-200 ${
                        isOpen ? 'rotate-0' : 'rotate-180'
                    }
                       ${isSelectOpen && index == 0 ? '-z-10' : 'z-0'}`}
                >
                    <img src={Arrowup} alt="arrow" />
                </div>
            </button>
            {isOpen && (
                <div className="px-4 py-2 bg-white flex flex-col rounded-b-xl mt-[-0.1rem]">
                    <hr />
                    {content}
                </div>
            )}
        </div>
    );
};

export default Accordion;
